import http from 'axios'

export default {
  getGrainesContractualiseesEtRecoltees: (username, anneeRecolte) => {
    return http.get(`/web/v1/${username}/graines/rs3/recolte/${anneeRecolte}/contractualisees-et-recoltees`)
  }
}
